/* eslint-disable */
/// This file is auto generated - do not edit manually
export const ChosenSizePrefix = 'Website.ProductVariantPicker.ChosenSizePrefix';
export const ChosenColorPrefix = 'Website.ProductVariantPicker.ChosenColorPrefix';
export const ChosenMiscellaneousPrefix = 'Website.ProductVariantPicker.ChosenMiscellaneousPrefix';
export const SelectButton = 'Website.ProductVariantPicker.SelectButton';
export const VariantImageAltText = 'Website.ProductVariantPicker.VariantImageAltText';
